import { generatePath } from 'react-router-dom'

export const ROUTES = {
  root: '/',
  login: '/login',
  confirmBooking: '/c',
  generalReception: '/general-reception',
  receiptBookingExit: '/receipt-booking/exit',
  generalReceptionDeskExit: '/general-reception-desk/exit',
  recordBookingWorkLog: '/record-booking-work-log',
  receiptBooking: '/receipt-booking',
  generalReceptionDesk: '/general-reception-desk',
  spDeliveryReport: '/sp/delivery-report/:deliveryReportUid',
  spDeliveryReportWork: '/sp/delivery-report/:deliveryReportUid/work',
  spDeliveryList: '/sp/delivery-report/:deliveryReportUid/list',
  spDeliveryWork: '/sp/delivery-report/:deliveryReportUid/work/:shipmentUid',
  spDeliveryWorkAttachmentPreview:
    '/sp/delivery-report/:deliveryReportUid/work/:shipmentUid/visits/:visitId/delivery-work/attachments/:attachmentId',
  spBerthManagement: '/sp/berth-management',
  sp: '/sp',
  mtenants: '/mtenants/:mid',
  warehouse: '/warehouse',
  notFound: '/not_found',
  forbidden: '/forbidden',
  berthAssignmentConditionCreate:
    '/warehouse/:warehouseId/:tenantId/berth-assignment-condition/create',
  // NOTE: :id は数値のみ。非数値にマッチすると詳細取得が 404 になるため正規表現で絞る
  berthAssignmentConditionEdit:
    '/warehouse/:warehouseId/:tenantId/berth-assignment-condition/:id(\\d+)/edit',
  deliveryPerformanceCsvDownload: '/delivery-performances/csv-download',
} as const

/**
 * ROUTES のパスパターンに実値を埋めたリンク先を組み立てるヘルパー。
 *
 * WHY: パスを文字列で二重に持つと片方だけ変えたときに静かにズレるため、
 * generatePath で ROUTES を単一の真実にする。
 */
export const buildRoute = {
  berthAssignmentConditionCreate: (params: { warehouseId: string; tenantId: string }) =>
    generatePath(ROUTES.berthAssignmentConditionCreate, params),
  berthAssignmentConditionEdit: (params: { warehouseId: string; tenantId: string; id: number }) =>
    generatePath(ROUTES.berthAssignmentConditionEdit, params),
} as const

export const PREVIEW_FILE_ROUTES = {
  normal: '/file-preview',
  driver: '/file-driver-preview',
} as const
